
<template>
  <div class="team-center">
    <div id="clan" v-show="selectedNavItem === 'team'">
      <ul v-if="teams" class="teams" ref="teams">
        <li
          v-for="(team, key) in teams"
          :key="key"
          @click="toDetail(team.teamCode, team.name)"
        >
          <div class="left">
            <div class="icon">
              <div
                class="head"
                :style="{
                  'background-image': `url(${team.avatar})`,
                }"
              ></div>
              <div class="frame"></div>
            </div>
            <div class="name">{{ team.name }}</div>
          </div>
          <UiButton
            class="focus-box"
            :class="{ focus: !team.isFollowed, unfocus: team.isFollowed }"
            @click.stop="handleFocus(team.teamCode, !team.isFollowed, team.name)"
          >
            <i/>
            <div class="label-box">
              <span class="label-shadow">{{ team.isFollowed ? '已关注' : '关注' }}</span>
              <span class="label-text">{{ team.isFollowed ? '已关注' : '关注' }}</span>
            </div>
          </UiButton>
        </li>
        <li v-if="teams.length % 2 !== 0" :style="{ opacity: 0 }"></li>
      </ul>
    </div>
    <!-- @deprecated 名人堂 tab 已下线: selectedNavItem 永远为 'team', 此处 v-show 恒为 false; 保留组件挂载点供未来恢复 -->
    <Star v-show="selectedNavItem === 'star'" />
  </div>
</template>

<script setup>
import { ref, computed, watch, nextTick, onUnmounted, useTemplateRef } from 'vue'
import { useRouter, onBeforeRouteLeave } from 'vue-router'
import { useAppStore } from '@/store'
import { usePrompt } from '@/composables/usePrompt'
import * as api from '@/service/index'
import Star from './star/index.vue'
import UiButton from '@/components/ui-button'

const router = useRouter()
const appStore = useAppStore()

// 模板里 ref="teams" 与数据 teams 同名：字符串模板 ref 会向同名 setup 绑定写入 DOM 元素。
// 因此数据存放在 teamsData，对模板暴露只读 computed（带空 setter 吞掉模板 ref 的写入），
// DOM 元素通过 useTemplateRef 获取。
const teamsData = ref([])
const teams = computed({
  get: () => teamsData.value,
  set: () => {}
})
const teamsEl = useTemplateRef('teams')
const { showPrompt } = usePrompt()

const inRequire = ref(false)
const selectedNavItem = ref('team')

const token = computed(() => appStore.token)
const seasonInfo = computed(() => appStore.seasonInfo)

watch(
  seasonInfo,
  (newVal) => {
    if (newVal && newVal.id) {
      // 获取战队信息
      getTeamsInfo(newVal.id)
    }
  },
  {
    immediate: true,
    deep: true
  }
)

onBeforeRouteLeave((to, from, next) => {
  if (from.name === 'Teams') {
    cacheScroll()
  }
  next()
})

// created
window.addEventListener('beforeunload', () => cacheScroll())

onUnmounted(() => {
  window.removeEventListener('beforeunload', () => cacheScroll())
})

function toDetail(teamCode) {
  router.push({
    name: 'Detail',
    params: { id: teamCode }
  })
}

function getTeamsInfo(seasonId) {
  // 每次切换到战队页签，都应该拉取新的数据，因为战队的排列顺序会经常变
  if(!token.value) return;
  let data = {

    token: token.value,
    seasonId:seasonId
  }
  appStore.reqTeamsList(data).then((response) => {
    if (response.status === 200) {

      teamsData.value = response.data

      // 存储本地
      // localStorage.setItem(
      //   "sausage-match:teams",
      //   JSON.stringify(this.teams)
      // );
      // 存储滚动位置
      setScrollPosition()
    } else {
      showPrompt(response.data)
    }
  })
}

function setScrollPosition() {
  // 定位滚动位置
  let scrollTop = sessionStorage?.getItem('scrollTop') || 0
  nextTick(() => {
    teamsEl.value.scrollTop = Number(scrollTop)
  })
}

function handleFocus(teamCode, status, teamName) {
  if (!inRequire.value) {
    inRequire.value = true
    let data = {
      seasonId: seasonInfo.value.id,
      teamCode: teamCode,
      status: status ? 1 : 0
    }
    api.reqFocusStatus(token.value, data).then((response) => {
      if (response.status === 200) {
        let subTeam = teams.value.find((team) => team.teamCode === teamCode)
        subTeam.isFollowed = status ? 1 : 0
        showPrompt(status ? '关注成功' : '取消关注成功')
      }

      inRequire.value = false
    })

    if (status) {
      // 埋点
      if (typeof tapdb === 'undefined') return
      // eslint-disable-next-line no-undef
      tapdb.trackEvent('关注', {
        '#team_id': teamName
      })
    } else {
      // 埋点
      if (typeof tapdb === 'undefined') return
      // eslint-disable-next-line no-undef
      tapdb.trackEvent('取消关注', {
        '#team_id': teamName
      })
    }
  }
}

function cacheScroll() {
  // 缓存列表滚动位置
  if (!teamsEl.value) return

  const scrollTop = teamsEl.value.scrollTop
  sessionStorage && sessionStorage.setItem('scrollTop', scrollTop)
}
</script>


<style lang="scss" scoped>

.team-center{
	width: 100%;
	height: 100%;
  box-sizing: border-box;
  padding: get_vh(24) get_vw(14) get_vh(16);
	overflow: hidden;

	#clan {
		height: 100%;
		overflow-x: hidden;
		overflow-y: scroll;
		@include hideScrollBar();
	
		.teams {
      width: 100%;
			height: 100%;
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			align-content: flex-start;

			li {
				box-sizing: border-box;
				// flex-basis: calc(50% - get_vw(8));
        width: get_vw(682);
				height: get_vw(118);
				background: url(https://website.xdcdn.net/poster/58881/26match/common/QRifDmjp.png) center/contain no-repeat;

				&:nth-child(n+3) {
					margin-top: get_vw(7);
				}
				overflow: hidden;
				display: flex;
				justify-content: space-between;
				align-items: center;
        filter: drop-shadow(0px get_vw(4) get_vw(4) rgba(#000, 0.2));

				cursor: pointer;
				-webkit-tap-highlight-color: transparent;
	
				.left {
					height: 100%;
					display: flex;
					align-items: center;
					margin-right: get_vw(20);

					.icon {
						position: relative;
						width: get_vw(92);
						height: get_vw(100);
						@include avatar_icon_frame;
						margin: 0 get_vw(38) 0 get_vw(30);
					}

					.name {
						font-size: get_vw(20);
						color: $black-33;
					}
				}
	
	
				.focus-box {
					width: get_vw(118);
					height: get_vw(44);
					font-size: get_vw(20);
					font-weight: bold;
					flex-shrink: 0;
          background-position: center;
          background-repeat: no-repeat;
          background-size: contain;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: get_vw(36);
          filter: drop-shadow(0px get_vw(4) get_vw(4) rgba(#000, 0.25));

          i {
            width: get_vw(26);
            height: get_vw(26);
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
            margin-right: get_vw(2);
          }

          .label-box .label-shadow {
            -webkit-text-stroke-width: 0.2em;
          }

          &.focus {
            background-image: url(https://website.xdcdn.net/poster/58881/26match/common/QRhBgfc9.png);
            i {
              background-image: url(https://website.xdcdn.net/poster/58881/26match/icon/QRhAdaky.png);
            }
            .label-box {
              .label-text { color: #513718; }
              .label-shadow { color: #fffac1; }
            }
          }

          &.unfocus {
            background-image: url(https://website.xdcdn.net/poster/58881/26match/common/QRhBgvj5.png);
            i {
              background-image: url(https://website.xdcdn.net/poster/58881/26match/icon/QRhAdy3n.png);
            }
            .label-box {
              .label-shadow { color: #57090A; }
            }
          }
				}
			}
		}
	}
}
</style>
